export const commentReducer = (state, {type, payload}) => {
    switch (type) {
        case "addComment":
            return [
                ...state,
                payload //new Comment
            ];
        case "removeComment":
            return [
                ...state.filter((comment) => comment.id !== payload) //payload == commentId
            ];
        case "likeComment":
            return state.map((item) => {
                if (item.id !== payload) {
                    return item
                }
                console.log({
                    ...item,
                    liked: true, likeCount: item.likeCount + 1
                });
                return {
                    ...item,
                    liked: true, likeCount: item.likeCount + 1
                }
            })
        case "dislikeComment":
            return state.map((item) => {
                if (item.id !== payload) {
                    return item
                }
                return {
                    ...item,
                    liked: false, likeCount: item.likeCount - 1
                }
            })
        case "initComment":
            console.log("initComment");
            console.log(payload);
            return payload;
        default:
            return state;
    }
}
